import { toast } from "sonner";

export async function shareStation(station) {
  const url = `${window.location.origin}/?station=${station.stationuuid}`;
  const text = `Listen to ${station.name?.trim()} on RadioHub`;
  try {
    if (navigator.share) {
      await navigator.share({ title: "RadioHub", text, url });
      return;
    }
  } catch (e) {
    if (e?.name === "AbortError") return;
  }
  try {
    await navigator.clipboard.writeText(`${text}: ${url}`);
    toast.success("Share link copied to clipboard");
  } catch {
    toast.error("Could not copy share link");
  }
}
